import React from 'react';
import PropTypes from 'prop-types';
import { DropdownButton, Dropdown } from 'react-bootstrap';
import { map, forEach, includes } from 'lodash';

export const getGroupList = tasklist => {
  const groupArray = [];
  forEach(tasklist, task => {
    if (!includes(groupArray, task.group)) {
      groupArray.push(task.group);
    }
  });
  return groupArray;
};

const TasksDropdown = ({ tasklist, selectGroup }) => {
  const groups = getGroupList(tasklist);
  const groupMenus = map(groups, group => {
    return (
      <Dropdown.Item key={group} onClick={() => selectGroup(group)}>
        {group}
      </Dropdown.Item>
    );
  });
  return (
    <DropdownButton id="tasklistDropdown" title="TaskList" className="ml-auto" alignRight>
      {groupMenus}
    </DropdownButton>
  );
};
TasksDropdown.propTypes = {
  tasklist: PropTypes.array.isRequired,
  selectGroup: PropTypes.func.isRequired
};

export default TasksDropdown;
